angular.module("controllers").controller("infoController", function ($scope, ngDialog) {

	
});